package com.futurions.portfolio.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import com.futurions.portfolio.components.AnimatedNetworkBackground
import com.futurions.portfolio.sections.AboutSection
import com.futurions.portfolio.sections.ContactSection
import com.futurions.portfolio.sections.Navbar
import com.futurions.portfolio.sections.ProfileHeader
import com.futurions.portfolio.sections.Projects
import com.futurions.portfolio.sections.ResumeSection
import com.futurions.portfolio.sections.SkillsSection
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

@Page
@Composable
fun HomePage() {
    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .background(Color.transparent)
            .position(Position.Relative)
    ) {
        // Background behind everything
        AnimatedNetworkBackground()

        // Content above
        Column(
            modifier = Modifier
                .zIndex(1)
                .fillMaxWidth()
                .padding(leftRight = 40.px, bottom = 40.px)
        ) {
            Navbar()
            ProfileHeader()
            AboutSection()
            SkillsSection()
          //  LanguagesSection()
          //  CodeSphere3D()
         //   SkillAnimationsSection()
         //   SkillOrbitSection()
            Projects()
            ResumeSection()
            ContactSection()

        }
    }
}







@Composable
fun ProfileSection() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(80.px)
            .id("profile") // Important: for scroll linking
    ) {
        ProfileHeader() // ← from your earlier function
    }
}


enum class Theme(val color: CSSColorValue) {
    Gray(color = rgb(r=238,g=238,b=238)),
    Blue(color = rgb(r=28,g=181,b=244))
}

val PageContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxSize()
            .padding(leftRight = 1.cssRem, top = 4.cssRem)
    }
    Breakpoint.MD {
        Modifier.maxWidth(100.cssRem)
    }
}

@OptIn(DelicateApi::class)
@Composable
fun PageLayout(
    title: String,
    content: @Composable ColumnScope.() -> Unit
) {
    val colorMode by ColorMode.currentState
    val breakpoint = rememberBreakpoint()

    LaunchedEffect(title) {
        document.title = "Vikramaditya Khupse - $title"
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .cursor(Cursor.None)
//            .styleModifier {
//                property("cursor", "url('${
//                    if (colorMode.isDark) Res.Image.CUSTOM_CURSOR_DARK
//                    else Res.Image.CUSTOM_CURSOR_LIGHT
//                }'), auto")
//            }
    ) {
        //  Matrix Rain Background
       AnimatedNetworkBackground()




        // ✅Overlay Layer (faint black for dark mode, white for light)
        Box(
            modifier = Modifier
                .id("overlay")
                .fillMaxSize()
                .zIndex(1)
                .backgroundColor(
                    if (colorMode.isDark)
                        com.varabyte.kobweb.compose.ui.graphics.Color.rgba(0, 0, 0, 0.5f)
                    else
                        com.varabyte.kobweb.compose.ui.graphics.Color.rgba(255, 255, 255, 0.5f)
                )
        )

        // Fixed Header (above everything)
        Box(
            modifier = Modifier
                .position(Position.Fixed)
                .zIndex(3)
                .fillMaxWidth()
        ) {

        }

        // Main Content Layer
        Column(
            modifier = PageContentStyle.toModifier()
                .fillMaxSize()
                .zIndex(2)
                .padding(top = 80.px)
        ) {
            content()
           // BackToTopButton()
        }
    }
}